<template>
  <v-footer
    class="my-3"
    dark
    color="transparent"
    height="auto">
    <v-card
      id="graaa"
      flat
      style="width: 100%;"
      tile
      class="white--text text-xs-center roundedcard">
      <v-card-text>
        <!-- <v-btn
          v-for="icon in icons"
          :key="icon"
          class="mx-3 white--text"
          icon>
          <v-icon size="24px">
            {{ icon }}
          </v-icon>
        </v-btn> -->
      </v-card-text>




      <v-card-text class="white--text pt-0">
        <div class="animated jackInTheBox delay-2s">
          <v-icon>fas fa-star fa-spin</v-icon>
          <span class="title">
            Congratulations!
          </span>
          <v-icon>fas fa-star fa-spin</v-icon>
        </div>
        <div class="animated bounceInLeft delay-2s">
          You've reached the Bottom of the Page!
        </div>
        <div class="animated bounceInRight delay-2s">
          And you know... This is <strong>awesome</strong>!
        </div>
      </v-card-text>

      <div class="mb-2">
        <v-btn 
          ref="button" 
          color="white"
          outline
          @click="$vuetify.goTo(0, {
            duration: 1000,
            offset: 0,
            easing: 'easeInOutQuint'
          })">
          Scroll back to Top
          <v-icon right>
            fas fa-arrow-square-up
          </v-icon>
        </v-btn>
      </div>


      <v-divider></v-divider>


      <v-card-text class="white--text">
        &copy;2019 — <strong>WeVent</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  data() {
    return{
      // icons: [
      //   'fas-facebook',
      //   'fas-twitter',
      //   'fas-google-plus',
      //   'fas-linkedin',
      //   'fas-instagram'
      // ]
    } 
  }
}
</script>


<style scoped>
#graaa {
   background-image: linear-gradient(330deg, #4FC3F7, #5C6BC0);
}

</style>
